import { useEffect, useState } from 'react';

import { checkKbAvailability, KB_AVAILABILITY_RETRY_MS } from '../lib';

// null while the probe is in flight: the header keeps the entry hidden
// until the content service confirms it is there. An unreachable service
// is re-probed on an interval so recovery brings the entry back.
export const useKbAvailability = (): boolean | null => {
  const [available, setAvailable] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;
    let timer: ReturnType<typeof setTimeout> | undefined;

    const probe = () => {
      checkKbAvailability().then((verdict) => {
        if (!active) return;

        setAvailable(verdict);

        if (!verdict) timer = setTimeout(probe, KB_AVAILABILITY_RETRY_MS);
      });
    };

    probe();

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, []);

  return available;
};
